import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";
import { useTranslation } from "../../../hooks/useTranslation";
import { getRuntimeEnv } from "../../../providers/getRuntimeEnv";

const VERSION = import.meta.env.VITE_APP_VERSION as string | undefined;
// the header's two pills (this one and the tools on the right) share it
export const PILL_HEIGHT = 34;

// Which environment this admin panel talks to, on every admin page: the two
// look the same otherwise, and suspending a seller or switching a flag on the
// live one touches real stores. Live is red, test is quiet.
export const EnvBadge = () => {
  const { translate } = useTranslation("pages.admin.header.env");
  const env = getRuntimeEnv();
  const live = env === "prod";
  const tone = live ? "error" : "info";

  return (
    <Tooltip
      placement="bottom-start"
      title={
        <Stack gap={0.25}>
          <span>{translate(`${env}.hint`)}</span>
          {VERSION && <span>{translate("version", { version: VERSION })}</span>}
        </Stack>
      }
    >
      <Stack
        direction="row"
        alignItems="center"
        gap={1}
        tabIndex={0}
        sx={{
          height: PILL_HEIGHT,
          px: 1.5,
          borderRadius: 2,
          border: "1px solid",
          borderColor: (theme) => alpha(theme.palette[tone].main, 0.4),
          bgcolor: (theme) =>
            alpha(theme.palette[tone].main, live ? 0.14 : 0.08),
          cursor: "default",
        }}
      >
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            bgcolor: `${tone}.main`,
          }}
        />
        <Typography
          variant="caption"
          fontWeight={700}
          sx={{ letterSpacing: 0.6, color: `${tone}.main` }}
        >
          {translate(`${env}.code`)}
        </Typography>
        <Typography
          variant="caption"
          sx={{ color: live ? `${tone}.main` : "text.secondary" }}
        >
          {translate(`${env}.label`)}
        </Typography>
      </Stack>
    </Tooltip>
  );
};
